module.exports = __webpack_public_path__ + "img/redpacklogo.c50c9037.png";